<template>
    <div class="new-meassage">
        <div v-if="resData.data" class="meassage-con">
            <h3>{{resData.data.title}}</h3>
            <span>時間：{{resData.data.updated_at}}</span>
            <p v-html="resData.data.content"></p>
            <!-- <div class="meassage-con-img lms-center"><img src="@p/assets/images/lesson.png" alt=""></div> -->
        </div>
        <ul class="meassage-footer">
            <li><p class="p-pointer" v-if="resData.prev" @click="$router.push({path:'/home/message/message-new',query:{id:resData.prev.id,title:resData.prev.title}})">上一條：{{resData.prev.title}}</p></li>
            <li><p class="p-pointer" v-if="resData.next" @click="$router.push({path:'/home/message/message-new',query:{id:resData.next.id,title:resData.next.title}})">下一條：{{resData.next.title}}</p></li>
        </ul>
    </div>
</template>
<script>
export default {
    data(){
        return{
            resData:{}
        }
    },
    created(){
        this.getNewsDetails(this.$route.query.id)
    },
    watch:{
        '$route.query':function(v){
            this.getNewsDetails(v.id)
        }
    },
    methods:{
        async getNewsDetails(id){
            await this.$http.message.getNewsDetails(id).then(res=>{
                if(res.status === 200){
                    let resData = res.data.data;
                    this.resData = resData
                }
            }).catch(v=>{})
        }
    },
}
</script>
<style lang="less" scoped>
.new-meassage{
    .meassage-con{
        min-height: 602px;
        background:rgba(241,241,246,1);
        margin-top: 24px;
        display: flex;
        align-items: center;
        flex-flow: column;
        padding: 0 100px;
        box-sizing: border-box;
        padding-bottom: 20px;
        
        h3{
            margin-top: 24px;
            font-size:18px;
            font-weight:400;
            margin-bottom: 18px;
        }
        span{
            font-size:14px;
            color:rgba(51,51,51,0.50);
            margin-bottom: 16px;
        }
        &-img{
            width: 733px;
            height: 311px;
            overflow: hidden;
            margin: 16px 0;
            img{
                height: 100%;
                max-width: 100%;
                max-height: 100%;
                display: block;
            }
        }
        p{
            text-indent:2em;
            color:rgba(51,51,51,0.70);
            font-size:14px;
        }
    }
    .meassage-footer{
        display: flex;
        padding: 45px 0;
        li{
            width: 50%;
            font-size:14px;
            color:rgba(51,51,51,0.70);
        }
        li:nth-child(2){
            text-align: right;
        }
        li:hover{
            color:rgba(77,142,246,1);
        }
    }
}
</style>
